import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0a12694"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help-text" }, "Choose what to include when your tree is uploaded.", -1))
const _hoisted_2 = {
  key: 0,
  class: "options"
}
const _hoisted_3 = { class: "option" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label soon" }, " Coming soon ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option disabled" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "form-check-input",
      disabled: ""
    }),
    /*#__PURE__*/_createTextVNode(" Sources & notes ")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "option disabled" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "form-check-input",
      disabled: ""
    }),
    /*#__PURE__*/_createTextVNode(" LDS details ")
  ])
], -1))

import { computed, ref } from 'vue'
import Modal from '@webapp/util/Modal.vue'
import { useSyncSessionStore } from './SyncSessionStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncOptionsModal',
  props: {
    sessionId: {}
  },
  emits: ['editLiving'],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  open,
})

const syncSessionStore = useSyncSessionStore()
const currentRef = computed(() => syncSessionStore.getState(props.sessionId))

const livingWindowCountRef = computed(() => currentRef.value?.sourceGraph?.livingWindowPersonIds.size ?? 0)
const livingPeopleLinkTextRef = computed(() => {
  if (livingWindowCountRef.value === 0) {
    return 'No living people found'
  }
  return `${currentRef.value?.livingWindowPersonIds.length ?? 0} of ${livingWindowCountRef.value} living people selected`
})

const modalRef = ref<InstanceType<typeof Modal>>()

function open() {
  modalRef.value?.open()
}

async function onEditLiving() {
  // Fully hide the modal (and its backdrop) before the parent opens the living-people modal.
  await modalRef.value?.close()
  emit('editLiving')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    info: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Upload options")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Done")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (currentRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentRef.value.syncOptions.includeLivingPersons) = $event)),
                  disabled: !livingWindowCountRef.value
                }, null, 8, _hoisted_4), [
                  [_vModelCheckbox, currentRef.value.syncOptions.includeLivingPersons]
                ]),
                _createTextVNode(" Include living people ")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-inline btn-link",
                disabled: !livingWindowCountRef.value,
                onClick: onEditLiving
              }, _toDisplayString(livingPeopleLinkTextRef.value), 9, _hoisted_5)
            ]),
            _hoisted_6,
            _hoisted_7,
            _hoisted_8
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})